export default function ProfileUploadIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="34" height="34" rx="17" fill="#3056D3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7646 11.4265C14.8728 11.2642 15.055 11.1667 15.25 11.1667H18.75C18.945 11.1667 19.1272 11.2642 19.2354 11.4265L20.2289 12.9167H22.25C22.7141 12.9167 23.1592 13.1011 23.4874 13.4293C23.8156 13.7575 24 14.2026 24 14.6667V21.0834C24 21.5475 23.8156 21.9927 23.4874 22.3209C23.1592 22.649 22.7141 22.8334 22.25 22.8334H11.75C11.2859 22.8334 10.8408 22.649 10.5126 22.3209C10.1844 21.9927 10 21.5475 10 21.0834V14.6667C10 14.2026 10.1844 13.7575 10.5126 13.4293C10.8408 13.1011 11.2859 12.9167 11.75 12.9167H13.7711L14.7646 11.4265ZM15.5622 12.3334L14.5687 13.8237C14.4605 13.9859 14.2784 14.0834 14.0833 14.0834H11.75C11.5953 14.0834 11.4469 14.1449 11.3375 14.2543C11.2281 14.3637 11.1667 14.512 11.1667 14.6667V21.0834C11.1667 21.2381 11.2281 21.3865 11.3375 21.4959C11.4469 21.6053 11.5953 21.6667 11.75 21.6667H22.25C22.4047 21.6667 22.5531 21.6053 22.6625 21.4959C22.7719 21.3865 22.8333 21.2381 22.8333 21.0834V14.6667C22.8333 14.512 22.7719 14.3637 22.6625 14.2543C22.5531 14.1449 22.4047 14.0834 22.25 14.0834H19.9167C19.7216 14.0834 19.5395 13.9859 19.4313 13.8237L18.4378 12.3334H15.5622Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0007 15.8334C16.0342 15.8334 15.2507 16.6169 15.2507 17.5834C15.2507 18.5499 16.0342 19.3334 17.0007 19.3334C17.9671 19.3334 18.7507 18.5499 18.7507 17.5834C18.7507 16.6169 17.9671 15.8334 17.0007 15.8334ZM14.084 17.5834C14.084 15.9726 15.3898 14.6667 17.0007 14.6667C18.6115 14.6667 19.9173 15.9726 19.9173 17.5834C19.9173 19.1942 18.6115 20.5001 17.0007 20.5001C15.3898 20.5001 14.084 19.1942 14.084 17.5834Z"
        fill="white"
      />
    </svg>
  );
}
